import PropTypes from "prop-types";
import ReactFilestack from "filestack-react";
import { FILESTACK_API_KEY } from "Constants";
import { Button } from "top-component-library";
import { BannerPreviewImage, LogoPreviewImage, PreviewCaption, UploadControls } from "../styles";

// Inline FileStack picker + preview + delete for a single customer image.
// onUpload receives the raw filesUploaded array from FileStack; the caller
// forwards it to the matching store endpoint.
const ImageUploadField = ({ recommendation, currentUrl, accept, maxSize, previewVariant, onUpload, onDelete }) => {
  const PreviewImage = previewVariant === "logo" ? LogoPreviewImage : BannerPreviewImage;
  const actionOptions = { accept, maxSize, maxFiles: 1 };

  return (
    <div>
      {recommendation && <p>{recommendation}</p>}
      <UploadControls>
        <ReactFilestack
          apikey={FILESTACK_API_KEY}
          actionOptions={actionOptions}
          onSuccess={(res) => onUpload(res.filesUploaded)}
          customRender={({ onPick }) => (
            <Button type="primary" onClick={onPick}>
              Select file
            </Button>
          )}
        />
        {currentUrl && (
          <Button danger onClick={onDelete}>
            Delete Image
          </Button>
        )}
      </UploadControls>
      <PreviewCaption>{currentUrl ? "Current Image" : "No Image Uploaded"}</PreviewCaption>
      {currentUrl && <PreviewImage src={currentUrl} alt="Current upload preview" />}
    </div>
  );
};

ImageUploadField.propTypes = {
  recommendation: PropTypes.string,
  currentUrl: PropTypes.string,
  accept: PropTypes.arrayOf(PropTypes.string),
  maxSize: PropTypes.number,
  previewVariant: PropTypes.oneOf(["banner", "logo"]),
  onUpload: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default ImageUploadField;
